import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { locale } from 'src/config';
import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { toParsableNumber } from 'src/utils/standards';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

const updateFine = async ({
  uuid,
  externalExplanation,
  adminComment,
  amount,
}: {
  uuid: string;
  externalExplanation?: string | null;
  adminComment?: string | null;
  amount?: string | null;
}) => {
  const payload = {
    admin_comment: adminComment,
    external_explanation: externalExplanation,
    amount: toParsableNumber(amount?.toString() ?? '0', locale),
  };

  const { data } = await putRequest(API.PUT.updateFine(uuid), payload);
  return data;
};

export const useUpdateFine = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateFine,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FINES] });
      handleSuccess(formatMessage(messages.fineSaved), 1000);
    },
    onError: handleError,
  });
};
